import { createFileRoute } from "@tanstack/react-router"
import Equipments from "@/app/settings/club/equipments/page"

export const Route = createFileRoute("/settings/club/equipments/")({
  component: Equipments,
})
